import React, {FC, useContext, useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import * as Yup from 'yup'
import {FormikProps, useFormik} from 'formik'
import {getPlanFeatures, updatePlan} from '../plan-list/core/_requests'
import {Plan} from '../plan-list/core/_models'
import {useNavigate, useParams} from 'react-router-dom'
import {useAuth} from '../../../auth'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'

const imageUrl = process.env.REACT_APP_IMAGE_UPLOADS
// Validation
const PlanDetailsSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
})

type Props = {
  initialValues: Plan
}
export const EditPlan: FC<Props> = ({initialValues}) => {
  const [data, setData] = useState<Plan>(initialValues)
  const {showAlert} = useContext(AlertContext)
  const navigate = useNavigate()
  const {id} = useParams()
  const [role, setRole] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [formImage, setFormImage] = useState<File | null>(null)
  const [planfeatures, setPlanFeatures] = useState<any>([])

  //get type
  const {currentUser} = useAuth()

  const type = currentUser?.type
  //end get type
  const formik: FormikProps<Plan> = useFormik<Plan>({
    initialValues,
    
    validationSchema: PlanDetailsSchema,
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      const updatedBy = currentUser?.userId;
      const updatedData = { ...data, ...values, updatedBy };
      updatePlan(updatedData, data.id).then((res) => {
        // Set the updated data to the state
        setData(updatedData);
        navigate('/plan', { replace: true });
        showAlert(res?.Message, res?.status);
      });
    },
  });

  useEffect(() => {
    getPlanFeatures().then((res: any) => {
      setPlanFeatures(res.data.data)
    })
  }, [])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Add Plan </h3>
        </div>
      </div>

      <div id='kt_account_profile_details'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/** Name */}
            <div className='row mb-6'>
              <div className='row'>
                <div className='col-lg- fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Name</label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Enter Plan '
                    {...formik.getFieldProps('name')}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.name}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Type */}
            <div className='row mb-6'>
              <label className='col-form-label required fw-bold fs-6'>Type</label>
              <select
                className='form-select form-select-solid form-select-lg'
                {...formik.getFieldProps('type')}
              >
                <option value=''>Select a name..</option>
                <option value='0'>Free</option>
                <option value='1'>Premium</option>
                <option value='2'>Gold</option>
                <option value='3'>Others</option>
              </select>
              {formik.touched.type && formik.errors.type && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.type}</div>
                </div>
              )}
            </div>
                {/* Plan Features */}
                <div className='row mb-6'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Plan Features</label>
                  <select
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Plan Features'
                    {...formik.getFieldProps('planfeaturesId')}
                  >
                    <option value=''>Select a Plan Features</option>
                    {planfeatures.map((item: any, i: any) => {
                      return (
                        <option key={i} value={item.id}>
                          {item.planFeaturesName}
                        </option>
                      )
                    })}
                  </select>
                  {formik.touched.planfeaturesId && formik.errors.planfeaturesId && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.planfeaturesId}</div>
                    </div>
                  )}
                </div>
                <div className='col-lg-6 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Name</label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Enter Employee Name'
                    {...formik.getFieldProps('name')}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.name}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Plan Validity */}
            <div className='row mb-6'>
              <div className='row'>
                <div className='col-lg- fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Plan Validity</label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Plan Validity '
                    {...formik.getFieldProps('planValidity')}
                  />
                  {formik.touched.planValidity && formik.errors.planValidity && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.planValidity}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Amount */}
            <div className='row mb-6'>
              <div className='row'>
                <div className='col-lg- fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Amount</label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Plan Validity '
                    {...formik.getFieldProps('amount')}
                  />
                  {formik.touched.amount && formik.errors.amount && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.amount}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button type='submit' className='btn btn-primary' disabled={loading}>
              {!loading && 'Save Changes'}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EditPlan
